module.exports = __webpack_public_path__ + "img/not-ready.af3a7d97.svg";